import React,{useState} from 'react'

const Form = () => {

   const [data, setData] = useState({
       name:"",
       email:"",
       number:""

       })

       let name, value;
       const userData=(event)=>{
           name=event.target.name;
           value=event.target.value;

           setData({...data, [name]:value });

       }

       const postData=(e)=>{

        e.preventDefault();
        alert(`Your name is ${data.name} your email is ${data.email} and your phone number is ${data.number}.`);

       }


    return (
       < >
       <div className="contact">
       <div className="container">
           <h1>Contact Us</h1>
           <div className="row">
               <div className="col-8 mx-auto">
       <form action="/" method="POST">
           <label htmlFor="Name">Name</label>
           <input type="text" name="name" className="form-control"  value={data.name} onChange={userData} placeholder="Name" />
           <label htmlFor="Email">Email</label>
           <input type="eamil" name="email" className="form-control" value={data.email} onChange={userData} placeholder="Eamil" />
           <label htmlFor="Number">Number</label>
           <input type="number" name="number" className="form-control" value={data.number} onChange={userData} placeholder="Number" />
           <div className="contact__1">
           <button type="button" className="btn btn-primary mt-3" id="btn__3" onClick={postData} >Submit</button>
           </div>
       </form>
       </div>
       </div>
       </div>
       </div>
       </>
    )
}

export default Form
